import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=fcbc3bd2&scoped=true&"
import script from "./PasswordChange.vue?vue&type=script&setup=true&lang=js&"
export * from "./PasswordChange.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbc3bd2",
  null
  
)

export default component.exports